import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const AccoladesAwardsSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [image, setImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [ACSectionDetails, setACSectionDetails] = useState(null);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */

    const [form, setForm] = useState({
        heading: "",
        intro_text: "",
        highlight_text: "",
    });

    /* ---------------- TABLE ROWS STATE ---------------- */
    const [rows, setRows] = useState([
        { title: "", description: "" },
    ]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        if (school_slug) fetchACSection();
    }, [school_slug]);

    const fetchACSection = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/about_page/get_accolades_awards_section/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const { section, rows } = res.data.data;

                setForm({
                    heading: section.heading || "",
                    intro_text: section.intro_text || "",
                    highlight_text: section.highlight_text || "",
                });

                setRows(
                    rows.length
                        ? rows
                        : [{ title: "", description: "" }]
                );

                setACSectionDetails(section);

                if (section.accolades_section_image) {
                    setPreviewImage(
                        `${baseAPIUrl}assets/images/aboutsec/${section.accolades_section_image}?t=${Date.now()}`
                    );
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- Input Change ---------------- */
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // row handler
    const handleRowChange = (index, e) => {
        const updated = [...rows];
        updated[index][e.target.name] = e.target.value;
        setRows(updated);
    };

    // + Add Row
    const addRow = () => {
        setRows([
            ...rows,
            {
                title: "",
                description: "",
            },
        ]);
    };

    /////// Delete row //////////

    const deleteRow = (index) => {
        if (rows.length <= 1) return;
        setRows(rows.filter((_, i) => i !== index));
    };

    /* ---------------- File Change ---------------- */
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setImage(file);

        if (file) {
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    /* ---------------- Submit ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(form));
            formData.append("rows", JSON.stringify(rows));

            if (image) {
                formData.append("section_image", image);
            }

            const res = await axios.post(
                "${baseAPIUrl}admin/about_page/add_edit_accolades_awards_section",
                formData,
                { withCredentials: true }
            );
            fetchACSection();
            setMessage(res.data.message);
            scrollToTop();
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveImage = async () => {
        const confirmDelete = window.confirm(
            "Are you sure you want to delete this image? This action cannot be undone."
        );

        if (!confirmDelete) return;

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            const res = await axios.post(
                `${baseAPIUrl}admin/about_page/delete_accolades_awards_section_image`,
                formData,
                { withCredentials: true }
            );

            if (res.data.status === 1) {
                setPreviewImage("");
                setImage(null);
                fetchACSection();
                scrollToTop();
                setMessage(res.data.msg);
            } else {
                scrollToTop();
                setMessage(res.data.msg || "Failed to delete image");
            }
        } catch (err) {
            console.error(err);
            scrollToTop();
            setMessage("Failed to delete image.");
        } finally {
            setLoading(false);
            scrollToTop();
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Accolades & Awards section</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Accolades & Awards section</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit Accolades & Awards section</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}
                                        {/* Heading */}
                                        <input type="hidden" name="school_slug" value={school_slug}></input>
                                        <div className="form-group">
                                            <label>Heading of section</label>
                                            <input
                                                type="text"
                                                name="heading"
                                                className="form-control"
                                                placeholder="Heading of section"
                                                value={form.heading}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Introduction text */}
                                        <div className="form-group">
                                            <label>Introduction text</label>
                                            <textarea
                                                name="intro_text"
                                                rows="5"
                                                className="form-control"
                                                placeholder="Introduction text"
                                                value={form.intro_text}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Affiliation Table */}
                                        <div className="form-group">
                                            <label>Content blocks</label>
                                            {rows.map((row, index) => (
                                                <div key={index} style={{ display: "flex", gap: "10px", marginTop: "7px" }}>
                                                    <textarea
                                                        className="form-control"
                                                        name="title"
                                                        placeholder="Title"
                                                        value={row.title}
                                                        onChange={(e) => handleRowChange(index, e)}
                                                    />

                                                    <textarea
                                                        className="form-control"
                                                        name="description"
                                                        placeholder="Description"
                                                        rows={6}
                                                        value={row.description}
                                                        onChange={(e) => handleRowChange(index, e)}
                                                    />

                                                    {/* DELETE BUTTON */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow(index)}
                                                        disabled={rows.length === 1}
                                                        title={
                                                            rows.length === 1
                                                                ? "At least one row is required"
                                                                : "Delete row"
                                                        }
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                            ))}

                                            <button className="btn btn-success mt-3" type="button" onClick={addRow}>
                                                + Add Row
                                            </button>
                                        </div>

                                        {/* Highlight text */}
                                        <div className="form-group">
                                            <label>Highlight text</label>
                                            <textarea
                                                name="highlight_text"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Highlight text`}
                                                value={form.highlight_text}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Image Upload */}
                                        <div className="form-group">
                                            <label>Section Image</label>

                                            <div className="input-group">
                                                <div className="custom-file">
                                                    <input
                                                        type="file"
                                                        className="custom-file-input"
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                                    />
                                                    <label className="custom-file-label">
                                                        {image ? image.name : "Choose file"}
                                                    </label>
                                                </div>
                                                <div className="input-group-append">
                                                    <span className="input-group-text">Upload</span>
                                                </div>
                                            </div>

                                            {/* Existing Image Preview */}
                                            {previewImage && (
                                                <div className="mt-2">
                                                    <img
                                                        src={previewImage}
                                                        alt="Preview"
                                                        className="img-fluid img-bordered"
                                                        style={{ maxWidth: "120px", display: "block", marginBottom: "8px" }}
                                                    />
                                                    {ACSectionDetails?.accolades_section_image && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-danger"
                                                            onClick={handleRemoveImage}
                                                        >
                                                            Remove Image
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}
export default AccoladesAwardsSection;